const processFilterSearchResults = (
  allDocs,
  params,
  activeCategoryFilter,
  residenceFavorites = {}
) => {
  let resultAll = [];
  let resultForFloorPlan = [];
  let resultForFavoriteResidences = [];
  let resultForBedrooms = [];
  let resultForType = [];
  let resultForLocation = [];
  let resultForOccupancy = [];

  if ( params ) {
    // Create filter parameters for all categories (for non–self‑free merging)
    const allFilterParams = { ...params };

    // For multi-select facets, we always want to ignore their own selections when
    // computing available options. That way, if a user has selected a floor plan,
    // for example, it doesn't force the facet to show only those floor plans.
    // ---
    // Floor Plan:
    const selfFreeFloorPlanParams = { ...params };
    if ( selfFreeFloorPlanParams.floor_plan ) {
      delete selfFreeFloorPlanParams.floor_plan;
    }
    resultForFloorPlan = allDocs.filter(
      ( doc ) => Object.entries( selfFreeFloorPlanParams ).every( ( [ category, selections ] ) => {
        const docCategoryUuid = doc[category]?.uuid || 'none';
        return Object.keys( selections ).some(
          ( selectedUuid ) => selectedUuid === docCategoryUuid,
        );
      } ),
    );

    // Bedrooms: (This one is working as expected, so we retain the conditional behavior.)
    if ( activeCategoryFilter === 'bedroom_data' ) {
      const selfFreeBedroomParams = { ...params };
      if ( selfFreeBedroomParams.bedroom_data ) {
        delete selfFreeBedroomParams.bedroom_data;
      }
      resultForBedrooms = allDocs.filter(
        ( doc ) => Object.entries( selfFreeBedroomParams ).every( ( [ category, selections ] ) => {
          const docCategoryUuid = doc[category]?.uuid || 'none';
          return Object.keys( selections ).some(
            ( selectedUuid ) => selectedUuid === docCategoryUuid,
          );
        } ),
      );
    } else {
      resultForBedrooms = allDocs.filter(
        ( doc ) => Object.entries( allFilterParams ).every( ( [ category, selections ] ) => {
          const docCategoryUuid = doc[category]?.uuid || 'none';
          return Object.keys( selections ).some(
            ( selectedUuid ) => selectedUuid === docCategoryUuid,
          );
        } ),
      );
    }

    // Type:
    const selfFreeTypeParams = { ...params };
    if ( selfFreeTypeParams.floor_plan_category ) {
      delete selfFreeTypeParams.floor_plan_category;
    }
    resultForType = allDocs.filter(
      ( doc ) => Object.entries( selfFreeTypeParams ).every( ( [ category, selections ] ) => {
        const docCategoryUuid = doc[category]?.uuid || 'none';
        return Object.keys( selections ).some(
          ( selectedUuid ) => selectedUuid === docCategoryUuid,
        );
      } ),
    );

    // Location:
    const selfFreeLocationParams = { ...params };
    if ( selfFreeLocationParams.map_building_grouping ) {
      delete selfFreeLocationParams.map_building_grouping;
    }
    resultForLocation = allDocs.filter(
      ( doc ) => Object.entries( selfFreeLocationParams ).every( ( [ category, selections ] ) => {
        const docCategoryUuid = doc[category]?.uuid || 'none';
        return Object.keys( selections ).some(
          ( selectedUuid ) => selectedUuid === docCategoryUuid,
        );
      } ),
    );

    // Occupancy:
    const selfFreeOccupancyParams = { ...params };
    if ( selfFreeOccupancyParams.residence_status ) {
      delete selfFreeOccupancyParams.residence_status;
    }
    resultForOccupancy = allDocs.filter(
      ( doc ) => Object.entries( selfFreeOccupancyParams ).every( ( [ category, selections ] ) => {
        const docCategoryUuid = doc[category]?.uuid || 'none';
        return Object.keys( selections ).some(
          ( selectedUuid ) => selectedUuid === docCategoryUuid,
        );
      } ),
    );

    // Also compute a general "all" result that applies every filter
    // (including those that aren't multi‑select)
    let filteredDocs = allDocs;

    // Apply favorite residences filter if selected
    if ( params.favorite_residences?.show_favorites ) {
      const favoriteResidenceUuids = residenceFavorites.residence || [];
      filteredDocs = filteredDocs.filter( ( doc ) => favoriteResidenceUuids.includes( doc.uuid ) );
    }

    resultAll = filteredDocs.filter(
      ( doc ) => {
        const filterEntries = Object.entries( allFilterParams ).filter( ( [ category ] ) => category !== 'favorite_residences' );
        if ( filterEntries.length === 0 ) {
          return true;
        }
        return filterEntries.every( ( [ category, selections ] ) => {
          const docCategoryUuid = doc[category]?.uuid;
          return docCategoryUuid && Object.keys( selections ).some(
            ( selectedUuid ) => selectedUuid === docCategoryUuid,
          );
        } );
      }
    );
  }

  return {
    resultAll,
    resultForFloorPlan,
    resultForBedrooms,
    resultForType,
    resultForLocation,
    resultForOccupancy,
    resultForFavoriteResidences,
  };
};

export default processFilterSearchResults;
